<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :counselingData="counselingData" :isUncompleted="true" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/counseling/List";
import { mapState } from "vuex";

export default {
  components: {
    List,
  },
  computed: {
    ...mapState("Counseling", ["counselingData"]),
  },
  methods: {},
  created() {
    this.$store.dispatch("Counseling/getUncompletedList", {
      ids: JSON.parse(this.$route.query.values),
    });
  },
};
</script>
